// @flow

import React, { useEffect } from 'react';
import type { Node } from 'react';
import { useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import type { Theme } from '../../../types';
import media from '../../../helpers/media';

type Props = {|
  children: Node,
  className: string,
  url?: string,
|};

const ACTIVE_CLASSNAME = 'active';
const ACTIVE_ID = 'active-nav-link';

const TabBarItem = ({
  children,
  className,
  url = '',
}: Props) => {
  const location = useLocation();

  useEffect(() => {
    const e = document.querySelector(`#${ACTIVE_ID}`);
    if (e && window.location.hash !== '#/') {
      // $FlowFixMe
      e.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }, []);

  const onTabBarItemClick = e => {
    if (e.target) {
      e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  };

  return (
    <NavLink
      activeClassName={ACTIVE_CLASSNAME}
      className={className}
      exact
      to={url}
      id={location.pathname === url ? ACTIVE_ID : ''}
      onClick={onTabBarItemClick}
    >
      {children}
    </NavLink>
  );
};

TabBarItem.defaultProps = {
  url: '',
};

// $FlowFixMe
export default styled<typeof TabBarItem, Theme>(TabBarItem)`
  font-size: 1rem;
  line-height: normal;
  background-color: ${props => props.theme.tabs.tabBackground};
  color: ${props => props.theme.tabs.tabTextColor};
  padding: 0.875rem;
  flex-grow: 1;
  text-align: center;
  text-decoration: none;

  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: ${props => props.theme.tabs.tabBorderColor};

  white-space: nowrap;

  ${media.sm(css`
    white-space: inherit;
  `)}

  &.${/* sc-sel */ACTIVE_CLASSNAME} {
    background-color: ${props => props.theme.tabs.activeTabBackground};
    border-color: ${props => props.theme.tabs.activeTabBorderColor};
    color: ${props => props.theme.tabs.activeTabTextColor};
  }

  &:first-child {
    border-top-left-radius: ${props => props.theme.tabs.borderRadius};
    border-bottom-left-radius: ${props => props.theme.tabs.borderRadius};
  }

  &:last-child {
    border-right-width: 1px;
    border-top-right-radius: ${props => props.theme.tabs.borderRadius};
    border-bottom-right-radius: ${props => props.theme.tabs.borderRadius};
  }
`;
